<template>
    <el-dialog :append-to-body="true" :visible="dialogShow" width="30%" :close-on-click-modal="false" @close="close" :class="[size,header ? 'with-header' : '']">
        <div class="el-dialog__header nowrap" slot="title"><wps-icon v-if="dialogIco" class="file-ico" :type="dialogIco"/>
        <span class="el-header-title nowrap" :title="dialogTitle">{{dialogTitle}}</span><span>{{extraData.endTitle}}</span>
        </div>
        <component :is="current"></component>
    </el-dialog>
</template>

<script>
import MoveFile from './file/MoveFile'
import DeleteRecord from './file/DeleteRecord'
import HistoryVersion from './file/History'
import Create from './Create'
import OpenClient from './OpenClient'
import Confirm from './Confirm'
import Feedback from './Feedback'
import DeleteFiles from './file/DeleteFiles'
import Share from './file/Share'
import Copy from './file/Copy'
import Rename from './file/Rename'
import Contact from './Contact'
import Mshare from './file/Mshare'
import CreateTeam from './team/CreateTeam'
import TeamShare from './team/TeamShare'
import Settings from './team/Settings'
import ExitTeam from './team/ExitTeam'
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
    data(){
        return {
        }
    },
    components:{
        MoveFile,
        DeleteRecord,
        HistoryVersion,
        Create,
        DeleteFiles,
        Share,
        Copy,
        Rename,
        Confirm,
        Feedback,
        Contact,
        Mshare,
        CreateTeam,
        TeamShare,
        Settings,
        ExitTeam,
        OpenClient
    },
    computed:{
        ...mapState([
            'dialogShow',
            'current',
            'size',
            'dialogTitle',
            'dialogIco',
            'header',
            'extraData'
        ])
    },
    methods:{
        ...mapActions([
            'close'
        ])
    }
}
</script>

<style>
.el-dialog{
    padding: 0 30px 30px;
    box-sizing: border-box;
    width: 450px!important;
}
.el-dialog__wrapper{
    position: relative;
}
.el-dialog__wrapper.with-header .el-dialog__header{
    display: flex;
}
.el-dialog__wrapper  .el-dialog__body {
    color: #48576a;
    padding: 0;
}
.el-dialog__wrapper.small .el-dialog{
    width: 450px!important;
}
.el-dialog__wrapper.large .el-dialog{
    width: 600px!important;
}
.el-dialog__wrapper.auto .el-dialog{
    position: fixed;
    width: 100%!important;
    margin: 0!important;
    padding: 0!important;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
.el-dialog .el-dialog__header {
    height: 78px;
    font-size: 18px;
    line-height: 78px;
    padding: 0;
    position: relative;
    display: flex;
    padding-right: 58px;
    color: #3c414b;
    align-items: center;
    min-width: 0;
    display: none;
}
.el-dialog__header .el-dialog__headerbtn{
    top: 32px;
    right: 0;
}
.dialog-label{
    vertical-align: middle;
    font-size: 14px;
    color: #48576a;
    line-height: 1;
    padding: 0 0 10px;
    box-sizing: border-box;
}
.el-dialog__header .components-icons{
    font-size: 30px;
}
.file-ico{
    margin-right: 12px;
}
.el-dialog .el-input__inner:not(.is-disabled) {
    border-radius: 2px!important;
    height: 36px;
    box-sizing: border-box;
}
.el-dialog .el-input__inner:not(.is-disabled):active, 
.el-dialog .el-input__inner:not(.is-disabled):focus, 
.el-dialog .el-input__inner:not(.is-disabled):hover,
.el-textarea__inner:focus,.el-textarea__inner:hover{
    border: 1px solid #2e68f8;
}
.dialog-foot{
    margin-top: 36px;
    text-align: right;
}
.dialog-foot button{
    margin-left: 10px;
}
.el-button--default:focus, .el-button--default:hover {
    color: #2e68f8;
    border-color: #2e68f8;
    background: transparent;
}
.dialog-wraper{
    padding-top: 36px;
}
.dialog-wraper.with-border,.delete-files,.share-file,.feedback,.open-client{
    border-top: 1px solid #e7e9eb;
}
.dialog-wraper p{
    word-break: break-all;
}
.el-button--danger {
    color: #fff;
    border-color: #e97663;
    background: #e97663;
}
.el-button--danger:focus, .el-button--danger:hover {
    border-color: #ff6e56;
    background: #ff6e56;
}
/* tree */

.tree-wraper{
    height: 300px;
    overflow: hidden;
    overflow-y: auto;
    border: 1px solid #d8d8d8;
    border-radius: 3px;
    padding: 0;
    margin-top: -36px;
    position: relative;
}
.tree-box .el-tree-node__content {
    line-height: 44px;
    height: 44px;
}
.tree-box .el-tree-node__content:hover {
    background: #fafcff;
}
.tree-box .components-icons,.tree-box .el-tree-node__loading-icon{
    font-size: 16px;
    margin: 0 3px;
    vertical-align: text-bottom;
}
.tree-box .tree-name{
    margin-left: 10px;
    overflow: hidden;
}
.tree-item{
    min-width: 0;
    max-height: 44px;
    display: flex;
    align-items: center;
}
.el-header-title{
    flex: 1;
    min-width: 0;
}
/* share */
.share-file{
    min-height: 100px;
    box-sizing: border-box;
}
.file-share-box{
    margin-bottom: 30px;
    border: 1px solid #e7e9eb;
    border-radius: 2px;
}
.link-body{
    line-height: 56px;
    display: flex;
    height: 56px;
    display: flex;
    min-width: 0;
}
.share-url{
    padding: 0 16px;
    flex: 1;
    border-right: 1px solid #e7e9eb;
    background: #f7f9fb;
    font-size: 18px;
    min-width: 0;
}
.copy-link{
    padding: 0 20px;
    cursor: pointer;
    font-size: 16px;
    color: #2e68f8;
}
.copy-link:hover,.link-permission,.link-expire-date{
    display: flex;
    align-items: center;
}
.link-expire{
    align-items: end;
    flex: 1;
    min-width: 0;
    display: flex;
}
.link-expire-tip{
    flex: 1;
    text-align: right;
    min-width: 0;
}
.link-permission-tip{
    text-align: left;
    min-width: 0;
}
.link-permission,.link-expire-date{
    color: #2e68f8;
    cursor: pointer;
}
.link-expire-date{
    margin-left: 4px;
}
.link-permission-box{
    justify-content: space-between;
    display: flex;
}
.link-permission-box .components-icons-down{
    font-size: 14px;
}
.el-dropdown-menu.list-actions{
    right: unset;
    min-width: 100px;
}
.link-error,.stop-share{
    color: #d81b30;
}
.el-dropdown-menu__item.list-action-item{
    padding: 0;
}
.el-dropdown-menu__item.list-action-item.checked{
    color: #2e68f8;
    background: transparent;
}
.el-dropdown-menu__item.list-action-item:focus, .el-dropdown-menu__item.list-action-item:not(.checked):hover{
    background: #f7f9fc;
    color: unset;
}
.invite-entry{
    margin-top: 24px;
    border-top: 1px solid #e7e9eb;
    padding: 24px 0 0;
}
.invite-entry .add-icon{
    background: #f7f9fb;
    display: inline-block;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    font-size: 10px;
    line-height: 30px;
    color: #2e68f8;
    text-align: center;
    transform: scale(.8) translateX(-4px);
}
.invite-text{
    color: #2e68f8;
    cursor: pointer;
}
.invited-members{
    color: #949aae;
}
.link-members-box {
    max-height: 175px;
    overflow-y: auto;
    margin-top: 24px;
    padding-right: 6px;
}
.file-share-member-item {
    display: flex;
    line-height: 40px;
    height: 40px;
}
.file-share-member-item .member-avatar-box {
    flex: 0 0 36px;
}
.file-share-member-item .member-avatar-box .member-avatar{
    display: flex;
    position: relative;
    height: 40px;
    justify-content: left;
    align-items: center;
}
.member-avatar img{
    border-radius: 50%;
}
.file-share-member-item .member-name-box {
    flex: 1;
    position: relative;
    min-width: 0;
}
.list-actions.member-permission{
    margin-top: 0;
}
.member-permission-select{
    cursor: pointer;
}
.link-nowrap{
    flex: 1;
    min-width: 0;
    display: inline-block;
}
/* share end */

.name-error{
    position: absolute;
    left: 0;
    bottom: -30px;
    color: #ff4949;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
}
.form-error .el-input__inner,.form-error .el-input__inner:hover,.form-error .el-input__inner:focus{
    border-color: #e97663!important;
}
.folder-name{
    position: relative;
}

.share-permission-forbid {
    margin-top: 20px;
}
.share-permission-forbid .el-checkbox__label, .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #48576a;
    font-weight: 400;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/index.vue